import { motion } from "framer-motion";
import { Heart, Instagram } from "lucide-react";
import { imageUrl } from "../lib/api";

const POSTS = [
  { img: "/api/images/trail-1.png", caption: "Weekend laps on private land", likes: "1,204" },
  { img: "/api/images/trail-2.png", caption: "Mud season is open", likes: "986" },
  { img: "/api/images/rider-1.png", caption: "First session, full gear", likes: "1,522" },
  { img: "/api/images/trail-3.png", caption: "Electric only, all day", likes: "2,041" },
  { img: "/api/images/rider-2.png", caption: "Kids squad rolling out", likes: "1,187" },
  { img: "/api/images/rider-3.png", caption: "Charged and ready", likes: "1,763" },
];

export const TrailFeed = () => (
  <section id="trailfeed" data-testid="trail-feed-section" className="relative py-28 lg:py-32">
    <div className="mx-auto max-w-7xl px-5 lg:px-8">
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
        className="flex flex-col gap-6 sm:flex-row sm:items-end sm:justify-between"
      >
        <div>
          <p className="mono-label flex items-center gap-3">
            <span className="inline-block h-px w-10 bg-brass" />
            From the Trail
          </p>
          <h2 className="mt-4 font-serif text-4xl font-semibold tracking-tight text-bone sm:text-5xl">
            Send it. <span className="italic text-brass">Share it.</span>
          </h2>
        </div>
        <a
          data-testid="instagram-follow-cta"
          href="https://instagram.com/1manameis"
          target="_blank"
          rel="noopener noreferrer"
          className="flex w-fit items-center gap-2 border border-brass/40 px-5 py-3 font-mono text-[10px] tracking-[0.2em] text-brass uppercase transition-all hover:bg-brass/10"
        >
          <Instagram className="h-3.5 w-3.5" />
          Follow @1manameis
        </a>
      </motion.div>

      <div className="mt-14 grid grid-cols-2 gap-3 lg:grid-cols-3">
        {POSTS.map((p, i) => (
          <motion.figure
            key={p.img}
            data-testid={`trail-post-${i + 1}`}
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-40px" }}
            transition={{ duration: 0.7, delay: (i % 3) * 0.1, ease: [0.22, 1, 0.36, 1] }}
            className="group relative overflow-hidden border border-brass/15"
          >
            <img
              src={imageUrl(p.img)}
              alt={p.caption}
              loading="lazy"
              className="aspect-square w-full object-cover transition-transform duration-700 group-hover:scale-105"
            />
            <figcaption className="absolute inset-0 flex flex-col justify-end bg-gradient-to-t from-forest-deep/95 via-forest-deep/30 to-transparent p-4 opacity-0 transition-opacity duration-500 group-hover:opacity-100">
              <p className="text-sm font-light text-bone">{p.caption}</p>
              <p className="mt-1.5 flex items-center gap-1.5 font-mono text-[10px] tracking-[0.15em] text-brass">
                <Heart className="h-3 w-3 fill-brass" />
                {p.likes}
              </p>
            </figcaption>
          </motion.figure>
        ))}
      </div>
    </div>
  </section>
);
